export default {"src":"/_next/static/media/suraksha_icon_light.005c3d39.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};